<template lang="">
    <Particles
                id="tsparticles"
                :particlesInit="particlesInit"
                :particlesLoaded="particlesLoaded"
                :options="options"
        />
</template>
<script>
import { loadFull } from "tsparticles";
export default {
  name:'CustomParticles',
  data() {
    return {
      options: {
fullScreen: {
    enable: true
  },
  detectRetina: true,
  // background: {
  //   color: "#ffffff"
  // },
  fpsLimit: 60,
  emitters: {
    direction: "top",
    life: {
      count: 30,
      duration: 0.1,
      delay: 0.2
    },
    rate: {
      delay: 0.01,
      quantity: 1
    },
    size: {
      width: 100,
      height: 0
    },
    position: {
      y: 100,
      x: 50
    }
  },
  particles: {
    number: {
      value: 0
    },
    destroy: {
      mode: "split",
      split: {
        count: 1,
        factor: { value: 1 / 3 },
        rate: {
          value: 100
        },
        particles: {
          color: {
            value: ["#D2BCB5", "#E8DAD1", "#DDCECE", "#EEEDE8", "#F8D373"]
          },
          stroke: {
            width: 0
          },
          number: {
            value: 0
          },
          collisions: {
            enable: false
          },
          opacity: {
            value: 1,
            animation: {
              enable: true,
              speed: 0.6,
              minimumValue: 0.1,
              sync: false,
              startValue: "max",
              destroy: "min"
            }
          },
          shape: {
            type: "circle"
          },
          size: {
            value: { min: 2, max: 3 },
            animation: {
              enable: false
            }
          },
          life: {
            count: 1,
            duration: {
              value: {
                min: 1,
                max: 2
              }
            }
          },
          move: {
            enable: true,
            gravity: {
              enable: false
            },
            speed: 2,
            direction: "none",
            random: true,
            straight: false,
            outMode: "destroy"
          }
        }
      }
    },
    life: {
      count: 1
    },
    shape: {
      type: "line"
    },
    size: {
      value: { min: 1, max: 100 },
      animation: {
        enable: true,
        sync: true,
        speed: 150,
        startValue: "random",
        destroy: "min"
      }
    },
    stroke: {
      color: {
        value: "#D2BCB5"
      },
      width: 1
    },
    rotate: {
      path: true
    },
    move: {
      enable: true,
      gravity: {
        acceleration: 15,
        enable: true,
        inverse: true,
        maxSpeed: 100
      },
      speed: { min: 10, max: 20 },
      outModes: {
        default: "destroy",
        top: "none"
      },
      trail: {
        fillColor: "#ffffff",
        enable: true,
        length: 10
      }
    }
  }
      }
    }

  },
  methods: {
    async particlesInit (engine) {
    await loadFull(engine)
    },
    async particlesLoaded(container){
    setTimeout(function () {
 	      container.destroy();
      }, 15000)
    }
  },
}
</script>
<style lang="">

</style>
